import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import isUndefined from 'lodash/isUndefined';
import { NoResults } from 'src/assets/index';
import { Routes } from 'src/constants/index';
import './style.scss';

interface IProps {
  isPetsAllowedError?: boolean;
  baseUrl: string;
  resortsCount: number;
  optionsCount: number;
  isSpecificCondo: boolean;
}

const zeroCount = 0;

export class NoAvailableCondosNotification extends React.Component<IProps, null> {
  render(): React.ReactNode {
    const { isPetsAllowedError = false, resortsCount, optionsCount, isSpecificCondo } = this.props;

    return (
      <div className="no-available-condos">
        <NoResults />
        <div className="no-available-condos__wrapper">
          <p className="no-available-condos__title">
            {isPetsAllowedError ? <FormattedMessage id="condo.not.pets.friendly" /> : null}
          </p>
          <div className="no-available-condos__description">
            {isPetsAllowedError ? (
              <FormattedMessage id="condo.not.pets.friendly.description" />
            ) : (
              <div className="no-available-condos__support-description-wrapper">
                <p className="no-available-condos__support-description">
                  <FormattedMessage id="demand.is.quite.high.for.this.area" />
                </p>
                <FormattedMessage id="request.a.custom.search" />
                <Link
                  to={`${Routes.CondoSearch}/submit-request`}
                  className="no-available-condos__support-link"
                >
                  <FormattedMessage id="click.this.link" />
                </Link>
              </div>
            )}
          </div>
          {!isUndefined(resortsCount) && resortsCount !== zeroCount ? (
            <p className="no-available-condos__count">
              {!isSpecificCondo ? (
                <FormattedMessage
                  values={{
                    resortsCount: resortsCount, optionsCount: optionsCount
                  }}
                  id="alternative.condo.title.without.below"
                />
              ) : null}
            </p>
          ) : null}
        </div>
      </div>
    );
  }
}
